module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team_type"
    }
  }, [(_vm.$route.meta.keepAliveSub2) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_vm._l((_vm.teams), function(teamitem, index) {
    return (teamitem.type == _vm.teamtypeId) ? _c('div', {
      key: index,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectTeam(teamitem)
        }
      }
    }, [_c('div', {
      staticClass: "box2"
    }, [_c('div', {
      staticClass: "class_box"
    }, [_c('div', {
      staticClass: "class_pic1",
      style: ({
        backgroundImage: 'url(' + teamitem.coverPictureUrl + ')'
      })
    }, [_c('div', {
      staticClass: "class_title"
    }, [_vm._v(_vm._s(_vm.showName(teamitem)))])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "teams": _vm.teams
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3f4ca7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeamType.vue
// module id = 1241
// module chunks = 4